import { IS_BROWSER } from './is-browser';

let initialized = false;

export const initializeGoogleAnalytics = (): void => {
  const measurementId = process.env.GA_WEB_ID;

  if (!IS_BROWSER || !measurementId || initialized) return;

  initialized = true;

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    // eslint-disable-next-line prefer-rest-params -- gtag.js ignores arrays, it needs the arguments object
    window.dataLayer?.push(arguments);
  };

  window.gtag('js', new Date());
  window.gtag('set', { cookie_flags: 'SameSite=None;Secure' });
  window.gtag('config', measurementId);
  // window.gtag('config', measurementId, { debug_mode: true }); // enable this to view debug view in google analytics for test purposes

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  document.head.appendChild(script);
};
